var _symbol, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallbang(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "dude-transit",
    viewBox: "0 -25.1 21.25 25.118"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M15.5-4.2l0.75-1.05l1-3.1l3.9-2.65v-0.05 c0.067-0.1,0.1-0.233,0.1-0.4c0-0.2-0.05-0.383-0.15-0.55c-0.167-0.233-0.383-0.35-0.65-0.35l-4.3,1.8l-1.2,1.65l-1.5-3.95 l2.25-5.05l-3.25-6.9c-0.267-0.2-0.633-0.3-1.1-0.3c-0.3,0-0.55,0.15-0.75,0.45c-0.1,0.133-0.15,0.25-0.15,0.35 c0,0.067,0.017,0.15,0.05,0.25c0.033,0.1,0.067,0.184,0.1,0.25l2.55,5.6L10.7-14l-3.05-4.9L0.8-18.7 c-0.367,0.033-0.6,0.184-0.7,0.45c-0.067,0.3-0.1,0.467-0.1,0.5c0,0.5,0.2,0.767,0.6,0.8l5.7,0.15l2.15,5.4l3.1,5.65L9.4-5.6 c-1.367-2-2.1-3.033-2.2-3.1C7.1-8.8,6.95-8.85,6.75-8.85C6.35-8.85,6.1-8.667,6-8.3C5.9-8,5.9-7.8,6-7.7H5.95l2.5,4.4l3.7,0.3 L14-3.5L15.5-4.2z M14.55-2.9c-0.333,0.4-0.45,0.85-0.35,1.35c0.033,0.5,0.25,0.9,0.65,1.2c0.4,0.3,0.85,0.417,1.35,0.35 c0.5-0.067,0.9-0.3,1.2-0.7c0.333-0.4,0.467-0.85,0.4-1.35c-0.066-0.5-0.3-0.9-0.7-1.2c-0.4-0.333-0.85-0.45-1.35-0.35 C15.25-3.533,14.85-3.3,14.55-2.9z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M2.416,3.535v24.786l11.387,2.847V0.604L2.416,3.535z M7.73,15.129c-1.271,0-2.302-1.855-2.302-4.144 c0-2.289,1.031-4.144,2.302-4.144c1.271,0,2.301,1.855,2.301,4.144C10.031,13.273,9,15.129,7.73,15.129z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 27.349,
    y: 10.765,
    fill: "#FFFFFF",
    width: 2.591,
    height: 0.709
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.598,
    y: 9.023,
    transform: "matrix(0.7026 -0.7116 0.7116 0.7026 1.5438 22.4478)",
    fill: "#FFFFFF",
    width: 2.057,
    height: 0.707
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.492,
    y: 11.916,
    transform: "matrix(0.7032 -0.711 0.711 0.7032 -0.9388 23.6404)",
    fill: "#FFFFFF",
    width: 0.707,
    height: 2.058
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.058,
    y: 12.806,
    transform: "matrix(0.9028 -0.43 0.43 0.9028 -3.2349 12.6689)",
    fill: "#FFFFFF",
    width: 0.708,
    height: 1.371
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.674,
    y: 8.355,
    transform: "matrix(0.5382 -0.8428 0.8428 0.5382 4.8332 26.2376)",
    fill: "#FFFFFF",
    width: 1.371,
    height: 0.707
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M16.362,12.138l7.997,0.004l2.054-1.137l-2.164-1.042h-7.887V12.138z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "topo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallbang);
export default __webpack_public_path__ + "static/media/wallbang.416cfc276ee9a62cb9c765b0b77017fd.svg";
export { ForwardRef as ReactComponent };